import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Upload from "../icons/Upload";
import Button from "../toolkit/ButtonV1";
import axios from "./fvAxios";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
function ExportToExcel({ url, filename, sheetname, headers }) {
  const [isLoading, setIsLoading] = useState(false);
  const exportToExcel = async () => {
    try {
      //   // Fetch data from the server
      //   const response = await fetch(url);
      setIsLoading(true);
      let response = await axios.get(url);

      const data = await response?.data?.data;

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Create a header row
      const headerRow = [headers.map((heading) => heading.text)];

      sheetname = sheetname ?? filename;

      //Convert data into array
      const convertedData = data.map((item) =>
        headers.map((heading) => {
          if (heading.changeActualData) {
            return heading.changedData.map(
              (content) => content[item[heading.id]]
            )[0];
          } else {
            return item[heading.id];
          }
        })
      );
      // Concatenate the header row with the data
      const excelData = [...headerRow, ...convertedData];

      // Convert the data to a worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetname);

      // Generate an Excel file buffer
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Create a blob object from the buffer
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      setIsLoading(false);
      // Save the file using FileSaver.js or any other library
      saveAs(blob, `${filename ?? "dowload"}.xlsx`);
    } catch (error) {
      setIsLoading(false);
      console.error("Error exporting data to Excel:", error);
    }
  };
  return (
    <Button
      className="buttonhidden"
      role="tertiary"
      variant="outlined"
      id="menu_btn"
      style={{ marginRight: "10px", marginLeft: "10px" }}
      trailingComponent={
        isLoading ? <CircularProgress size={20} /> : <Upload />
      }
      onClick={exportToExcel}
    />
  );
}

export default ExportToExcel;
